import React from 'react';
export function Container({
  className = '',
  children
}: {
  className?: string;
  children: React.ReactNode;
}) {
  return <div className={`max-w-container mx-auto px-5 md:px-8 lg:px-10 ${className}`} data-id="element-752" data-mp="1lmrq2ar915a1">
      {children}
    </div>;
}